import { render, staticRenderFns } from "./QuestionProportion.vue?vue&type=template&id=1f47e2f4&scoped=true&"
import script from "./QuestionProportion.vue?vue&type=script&lang=js&"
export * from "./QuestionProportion.vue?vue&type=script&lang=js&"
import style0 from "./QuestionProportion.vue?vue&type=style&index=0&id=1f47e2f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47e2f4",
  null
  
)

export default component.exports